import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'

import { ParcelZoningCodesContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-codes/content'

const ParcelZoningCodes = () => {
  return (
    <WidgetCard
      id="zoning-codes"
      title="Zoning Codes"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      loaderHeight={450}
      sections={[
        {
          content: <ParcelZoningCodesContent />,
        },
      ]}
    />
  )
}

export default ParcelZoningCodes
